import { BaseChannel } from "@app/channels/base_channel";

export class TrackingChannel extends BaseChannel {
  connected(){
    super.connected();
    console.log("Tracking channel connected!");
  }

  disconnected() {
    super.disconnect();
    console.log("Tracking channel disconnected!");
  }

  received(data){
    if (this.trackingController) {
      this.trackingController.handleMessage(data);
    }
  }
}
